<template lang="pug">
  div.account-forget
    el-form(:model="ruleForm",
      :rules="rules",
      ref="register")
      el-form-item(prop="username")
        el-input(v-model="ruleForm.username", placeholder="请输入手机号")
          template(slot="prepend") +86
      el-form-item(prop="verifyCode")
        div.verify-code
          el-input(v-model="ruleForm.verifyCode", placeholder="短信验证码")
          button.get-code(:disabled="getCode || sentCd" @click.prevent.stop="sentCode") {{codeZh}}
      el-form-item(prop="password")
        el-input(v-model="ruleForm.password", type="password", placeholder="请输入6~12位密码")
      el-form-item(prop="checkPassword")
        el-input(v-model="ruleForm.checkPassword", type="password", placeholder="确认新密码")
    button.submit(:disabled="disabled", @click.prevent="reset") 确认
    div.foot
      span 已有账号？
      a(@click="$emit('toComponent', 'login')") 登录
</template>

<script>
import _ from 'lodash'
import client from '../server/server'
export default {
  name: 'AccountForget',
  data () {
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value))) {
        callback(new Error('请输入正确的手机号格式'))
      } else {
        callback()
      }
    }
    const validateCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      getCode: true,
      sentCd: false,
      disabled: true,
      codeZh: '获取验证码',
      ruleForm: {
        username: '',
        verifyCode: '',
        password: '',
        checkPassword: ''
      },
      rules: {
        username: [
          { validator: validateUsername, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 12, message: '密码长度在 6 到 12 个字符', trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validateCheck, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    ruleForm: {
      deep: true,
      handler (val) {
        if (_.compact(Object.values(val)).length === Object.keys(val).length || this.again) {
          this.assign = true
          this.$refs.register.validate((valid) => {
            this.disabled = !valid
          })
        }
      }
    },
    'ruleForm.username' () {
      this.$refs.register.validateField('username', (valid) => {
        this.getCode = !!valid
      })
    }
  },
  methods: {
    sentCode () {
      let data = {
        phone: this.ruleForm.username
      }
      this.sentCd = true
      let time = 60
      let sentInterval = setInterval(() => {
        time--
        this.codeZh = `${time}s后再次获取`
        if (+time <= 0) {
          clearInterval(sentInterval)
          this.codeZh = '再次获取验证码'
          this.sentCd = false
        }
      }, 1000)
      client.getResetIdentifyCode(data)
    },
    reset () {
      let data = {
        password: this.ruleForm.password,
        phone: this.ruleForm.username,
        authCode: this.ruleForm.verifyCode
      }
      client.resetPassword(data)
        .then(res => {
          if (res.success) {
            this.$message({
              message: res.message,
              type: 'success',
              center: true
            })
            // todo 重置密码success
            let form = {
              phone: data.phone,
              password: data.password
            }
            this.$store.dispatch('UserLogin', form)
              .then(res => {
                this.$router.push({
                  name: 'EventIndex'
                })
              })
              .catch(err => {
                console.log(err)
                // this.errors.add('password', err)
              })
          } else {
            this.$message({
              message: res.message,
              type: 'error',
              center: true
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .account-forget{
    margin: 0 32px;
    .verify-code{
      display: flex;
      .get-code{
        min-width: 104px;
        height: 40px;
        border-radius: 4px;
        border: solid 1px #3989cb;
        color: #3989cb;
        background-color: #fff;
        margin-left: 10px;
        font-size: 13px;
        &[disabled] {
          border: solid 1px #DCDFE6;
          color: #DCDFE6;
          cursor: not-allowed;
        }
      }
    }
    .submit{
      margin-top: 27px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #3989cb;
      border-radius: 4px;
      width: 100%;
      height: 40px;
      font-size: 14px;
      color: #fff;
      &[disabled] {
        background-color: #d5d6d9;
        cursor: not-allowed;
      }
    }
    .foot{
      margin: 40px 0 20px;
      text-align: right;
      font-size: 12px;
      a{
        color: #3989cb;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/AccountForget.vue